export default __webpack_public_path__ + "static/media/usdt.8d9946cf.svg";